module.exports = __webpack_public_path__ + "static/media/en-check-remaining-traffic_3.4e670bf7.png";